import React from 'react';

import { Grid, ToggleButton, ToggleButtonGroup, alpha, useTheme } from '@mui/material';

export type LuxPlusPayloadBuilderMode = 'promoCardCarousel' | 'promoBannerCarousel';

interface LuxPlusPayloadBuilderToolbarProps {
  selectedMode: LuxPlusPayloadBuilderMode;
  standaloneActions?: React.ReactNode;
  onRequestModeChange: (mode: LuxPlusPayloadBuilderMode) => void;
}

export default function LuxPlusPayloadBuilderToolbar({
  selectedMode,
  standaloneActions,
  onRequestModeChange,
}: LuxPlusPayloadBuilderToolbarProps) {
  const theme = useTheme();

  const handleModeChange = (_: React.MouseEvent<HTMLElement>, value: LuxPlusPayloadBuilderMode | null) => {
    if (!value || value === selectedMode) return;
    onRequestModeChange(value);
  };

  const toggleGroupSx = {
    gap: 1,
    bgcolor: 'transparent',
    '& .MuiToggleButtonGroup-grouped': {
      flex: 1,
      borderRadius: '4px !important',
      border: '1px solid transparent !important',
      marginLeft: '0 !important',
      textTransform: 'none',
      fontWeight: 600,
      color: 'text.secondary',
      '&:not(:first-of-type)': {
        marginLeft: `${theme.spacing(1)} !important`,
        borderLeft: '1px solid transparent !important',
      },
      '&.Mui-selected': {
        color: 'primary.main',
        bgcolor: alpha(theme.palette.primary.main, 0.08),
        borderColor: `${alpha(theme.palette.primary.main, 0.24)} !important`,
        '&:hover': {
          bgcolor: alpha(theme.palette.primary.main, 0.12),
        },
      },
      '&:not(.Mui-selected):hover': {
        bgcolor: alpha(theme.palette.action.hover, 0.04),
      },
    },
  } as const;

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid size={{ xs: 12, md: 5.4 }} sx={{ py: 0.5, pr: { md: 2 } }}>
        <ToggleButtonGroup
          exclusive
          fullWidth
          value={selectedMode}
          onChange={handleModeChange}
          color="primary"
          size="small"
          sx={toggleGroupSx}
        >
          <ToggleButton value="promoCardCarousel">Promo Cards</ToggleButton>
          <ToggleButton value="promoBannerCarousel">Promo Banners</ToggleButton>
        </ToggleButtonGroup>
      </Grid>

      <Grid
        size={{ xs: 12, md: 6.6 }}
        sx={{
          py: 0.5,
          display: 'flex',
          justifyContent: 'flex-end',
          minWidth: 0,
        }}
      >
        {standaloneActions}
      </Grid>
    </Grid>
  );
}
